import axios from "axios";
import swal from "sweetalert";

// encabezados que se deben de enviar al api de la aseguradora general (nos lo compartieron)
var requestOptions = {
  Authorization: "Basic QUczbmVyNGwyMDE4OkFHNHBwUDRzc3cwcmQ",
  "Content-Type": "application/json",
  DeviceId: "2334234234",
  AppVersion: "1.1.1",
  OSVersion: "1.1.1",
  Os: "web",
  SessionId:
    "e3577b2ffbb60e5f84aa24ab4dbecc29f8950bc7ab9f04eddee1b3538d3d94496a901778edd7990e19308b2b0f4c0a240b21eeb1551cffdf1608d072ba18f00b3bb01c4beb7cd6be690805443f71b01b10e965737620b26c42ca164a1372f8cbdb3b1b00e798b55decc12cd74be5bdafc071b8f50d5f9fac49b917a01825ed9d3d831cea168f9a5052d78a3c0292d8557ace6b8162c591ebfdf93a663b457f2d89e21078cfea483c834986eb1c3e5232",
};

const apiClient = axios.create({
  baseURL: process.env.REACT_APP_API_UR,
  headers: {
    "Content-Type": "application/json",
  },
});

const tokenApiCarnet =
  "YXBpX2lzZV9jb25zdWx0YXM6MjAyNTAzMjYwNzE3MTk1MTE1OjIwMjpVU1JXRUJJU0U6ODk6LTE=";

// Interceptor de solicitud: agregar token si existe
apiClient.interceptors.request.use(
  (config) => {
    if (config.url && config.url.includes("Carnet")) {
      config.headers["Authorization"] = `agsa ${tokenApiCarnet}`;
    }else if (config.url && config.url.includes("api-ag")) {
      config.headers = {
        ...config.headers,
        ...requestOptions,
      };
    }
     else {
      config.headers["Authorization"] = `Bearer ${sessionStorage.getItem("jwtToken")}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Interceptor de respuesta: manejo de errores globales
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
       swal("Aviso", "No se pudo completar la acción. Es necesario volver a iniciar sesión.", "warning").then(() => {
        window.location.reload();
        return new Promise(() => {});
      });
    } else if (error.response.status === 409) {
      swal(
        "Aviso",
        "No se encontró tu carnet. Ponte en contacto con tu asesor!!",
        "warning"
      ).then(() => {
        // Esto se ejecuta cuando el usuario hace clic en OK        
        return new Promise(() => {});
      });
    } else {
      swal(
        "Aviso",
        "Ha ocurrido un error por favor intente de nuevo!!",
        "warning"
      ).then(() => {
        window.location.reload();
        return new Promise(() => {});
      });
    }

    return Promise.reject(error);
  }
);

export default apiClient;
